import type { ComputedRef } from 'vue'
import { computed, watch, nextTick } from 'vue'

import useUser from '@/features/users/hooks/use-user.hook'

export default function useProfileDescription(userId: ComputedRef<string | undefined>, holderClassName: string) {
  const { userRef } = useUser(userId)

  const hasDescriptionRef = computed<boolean>(() => {
    return !!userRef.value?.description && userRef.value.description.trim().length > 0
  })

  watch(
    userRef,
    async (user) => {
      if (user?.description) {
        await nextTick()
        const holder = document.getElementById(holderClassName)
        if (holder) {
          holder.innerHTML = user.description
        }
      }
    },
    { immediate: true },
  )

  return {
    hasDescriptionRef,
  }
}
